export default {
  kr: '₩',
};
